// extracted by mini-css-extract-plugin
module.exports = {"container":"BannerGallery_container__k1eCm","image":"BannerGallery_image__3F7rT","highlight":"BannerGallery_highlight__3-8SK","others":"BannerGallery_others__1qmzT"};